import produce from "immer";
import {
  //
  ADD_HOME_GROUP_ADMIN,
  ADD_HOME_GROUP_ADMIN_FAILURE,
  ADD_HOME_GROUP_ADMIN_SUCCESS,
  //
  DELETE_HOME_GROUP_ADMIN,
  DELETE_HOME_GROUP_ADMIN_SUCCESS,
  DELETE_HOME_GROUP_ADMIN_FAILURE,
  //
  EDIT_HOME_GROUP_ADMIN,
  EDIT_HOME_GROUP_ADMIN_FAILURE,
  EDIT_HOME_GROUP_ADMIN_SUCCESS,
  //
  FETCH_HOME_GROUP_ADMINS,
  FETCH_HOME_GROUP_ADMINS_FAILURE,
  FETCH_HOME_GROUP_ADMINS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  OPEN_ADMIN_ADD_MODAL,
  CLOSE_ADMIN_ADD_MODAL,
  //
  OPEN_ADMIN_EDIT_MODAL,
  CLOSE_ADMIN_EDIT_MODAL,
  //
  INVITE_ADMIN,
  INVITE_ADMIN_SUCCESS,
  INVITE_ADMIN_FAILURE,
  //
  GET_USER_LIST,
  GET_USER_LIST_SUCCESS,
  GET_USER_LIST_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingHomesAdmin: false,
  HomesAdmin: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentHomeAdmin: {},
  // Delete
  isDeleting: false,
  //
  isAdminAddModalOpen: false,
  isAdminEditModalOpen: false,
  isSearching: false,
  searchHomeList: [],
  isInviting: false,
  isGettingUsers: false,
  usersList: {},
};

const HomeGroupAdminReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_HOME_GROUP_ADMINS:
        draft.isFetchingHomesAdmin = true;
        draft.currentHomeAdmin = {};
        break;
      case FETCH_HOME_GROUP_ADMINS_SUCCESS:
        draft.isFetchingHomesAdmin = false;
        draft.HomesAdmin = action.payload;
        break;
      case FETCH_HOME_GROUP_ADMINS_FAILURE:
        draft.isFetchingHomesAdmin = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentHomeAdmin = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentHomeAdmin = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_HOME_GROUP_ADMIN:
        draft.isSubmitting = true;
        break;
      case ADD_HOME_GROUP_ADMIN_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_HOME_GROUP_ADMIN_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_HOME_GROUP_ADMIN:
        draft.isSubmitting = true;
        break;
      case EDIT_HOME_GROUP_ADMIN_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_HOME_GROUP_ADMIN_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_HOME_GROUP_ADMIN:
        draft.isDeleting = true;
        break;
      case DELETE_HOME_GROUP_ADMIN_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_HOME_GROUP_ADMIN_FAILURE:
        draft.isDeleting = false;
        break;
      case OPEN_ADMIN_ADD_MODAL:
        draft.isAdminAddModalOpen = true;
        draft.currentHomeAdmin = {};
        break;
      case CLOSE_ADMIN_ADD_MODAL:
        draft.isAdminAddModalOpen = false;
        draft.currentHomeAdmin = {};
        break;
      case OPEN_ADMIN_EDIT_MODAL:
        draft.isAdminEditModalOpen = true;
        draft.currentHomeAdmin = {};
        break;
      case CLOSE_ADMIN_EDIT_MODAL:
        draft.isAdminEditModalOpen = false;
        draft.currentHomeAdmin = {};
        break;

      //
      case INVITE_ADMIN:
        draft.isInviting = true;
        break;
      case INVITE_ADMIN_SUCCESS:
        draft.isInviting = false;
        break;
      case INVITE_ADMIN_FAILURE:
        draft.isInviting = false;
        break;

      //
      case GET_USER_LIST:
        draft.isGettingUsers = true;
        draft.usersList = {};
        break;
      case GET_USER_LIST_SUCCESS:
        draft.isGettingUsers = false;
        draft.usersList = action.payload;
        break;
      case GET_USER_LIST_FAILURE:
        draft.isGettingUsers = false;
        draft.usersList = {};
        break;

      default:
        return state;
    }
  });

export default HomeGroupAdminReducer;
